var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvening(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B2722;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000030488371773531238330000011367487327798220433_);}\n\t.st3{fill:url(#SVGID_00000176005322880780622210000000388983003698205850_);}\n\t.st4{fill:url(#SVGID_00000064347069108312517840000012240918423754160512_);}\n\t.st5{fill:url(#SVGID_00000146464789415905397080000001290803546875535501_);}\n\t.st6{fill:url(#SVGID_00000051355785940944377800000016030759384874849210_);}\n\t.st7{fill:#282522;}\n\t.st8{fill:#3E3C3B;}\n\t.st9{fill:#373534;}\n\t.st10{fill:#323130;}\n\t.st11{fill:#484645;}\n\t.st12{fill:#242220;}\n\t.st13{fill:#2E2C2B;}\n\t.st14{fill:#2F2D2C;}\n\t.st15{fill:#413F3E;}\n\t.st16{fill:#545251;}\n\t.st17{fill:#40403F;}\n\t.st18{fill:#464443;}\n\t.st19{fill:#3C3A3A;}\n\t.st20{fill:#272625;}\n\t.st21{fill:#323030;}\n\t.st22{fill:url(#SVGID_00000141441072843801685270000001733016407137769151_);}\n\t.st23{fill:#2B2623;}\n\t.st24{fill:#453E30;}\n\t.st25{fill:url(#SVGID_00000144300698788615441570000012639796278904168343_);}\n\t.st26{fill:#E5BB20;}\n\t.st27{fill:#3E382E;}\n\t.st28{fill:#D9B227;}\n\t.st29{fill:#282623;}\n\t.st30{fill:#252022;}\n\t.st31{fill:#343231;}\n\t.st32{fill:#2B2A28;}\n\t.st33{fill:#312F2E;}\n\t.st34{fill:#2A2827;}\n\t.st35{fill:#2D2B2A;}\n\t.st36{fill:#252322;}\n\t.st37{fill:#403F3E;}\n\t.st38{fill:#3B3938;}\n\t.st39{fill:url(#SVGID_00000117639407328848057290000003283040617935722907_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.98,19.45c-2.76,0-5.53-0.04-8.29,0.02c-0.9,0.02-1.11-0.25-1.13-1.12c-0.14-4.89,3.28-9.07,8.07-9.75 c4.85-0.69,9.37,2.36,10.56,7.11c0.23,0.94,0.26,1.89,0.26,2.85c0,0.68-0.2,0.92-0.92,0.91C23.68,19.43,20.83,19.45,17.98,19.45 L17.98,19.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.8754,
    y1: 52.3959,
    x2: 27.0974,
    y2: 52.3959,
    gradientTransform: "matrix(1 0 0 -1 0 73.0309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A26"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.05,20.25c2.79,0,5.58-0.01,8.37,0.01c0.25,0,0.69-0.21,0.68,0.32c-0.01,0.48-0.37,0.47-0.73,0.47 c-5.55-0.01-11.1-0.01-16.66-0.01c-0.11,0-0.23,0-0.34-0.01c-0.37,0-0.51-0.26-0.49-0.56c0.02-0.34,0.34-0.22,0.54-0.22 c2.23-0.01,4.45,0,6.68,0C16.75,20.25,17.4,20.25,18.05,20.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014607280883882828700000017900093817305475263_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.5108,
    y1: 50.7029,
    x2: 26.4487,
    y2: 50.7029,
    gradientTransform: "matrix(1 0 0 -1 0 73.0309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014607280883882828700000017900093817305475263_)"
    },
    d: "M18.06,21.95c2.54,0,5.08-0.01,7.63,0.01 c0.26,0,0.73-0.22,0.76,0.22c0.03,0.51-0.41,0.57-0.85,0.57c-3.42-0.01-6.83-0.01-10.25-0.01c-1.61,0-3.22,0-4.83,0 c-0.22,0-0.46,0.01-0.67-0.06c-0.22-0.08-0.37-0.32-0.33-0.54c0.06-0.31,0.37-0.18,0.57-0.18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060031188828070410200000000969609479325947827_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.5172,
    y1: 48.9753,
    x2: 25.4172,
    y2: 48.9753,
    gradientTransform: "matrix(1 0 0 -1 0 73.0309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060031188828070410200000000969609479325947827_)"
    },
    d: "M10.52,23.67c5.01,0,9.93,0,14.9,0 c-0.09,0.55-0.38,0.77-0.91,0.77c-4.34-0.01-8.68-0.01-13.01,0C11,24.45,10.71,24.24,10.52,23.67z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155125446179203332550000005368643295285713830_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.1172,
    y1: 47.2553,
    x2: 23.8272,
    y2: 47.2553,
    gradientTransform: "matrix(1 0 0 -1 0 73.0309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155125446179203332550000005368643295285713830_)"
    },
    d: "M23.83,25.41 c-0.41,0.49-0.82,0.75-1.41,0.74c-2.94-0.01-5.87-0.02-8.81,0c-0.6,0-0.99-0.27-1.49-0.75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088851361343571306270000013448308647308745094_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.6372,
    y1: 45.7423,
    x2: 20.3072,
    y2: 45.7423,
    gradientTransform: "matrix(1 0 0 -1 0 73.0309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088851361343571306270000013448308647308745094_)"
    },
    d: "M20.31,27.08c-1.57,0.55-3.12,0.56-4.67,0 C17.2,27.08,18.76,27.08,20.31,27.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011013312269561172470000001257704362614800258_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.0837,
    y1: 59.0485,
    x2: 26.9859,
    y2: 59.0485,
    gradientTransform: "matrix(1 0 0 -1 0 73.0309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011013312269561172470000001257704362614800258_)"
    },
    d: "M18.03,18.91c-2.68,0-5.37-0.02-8.05,0.01 c-0.65,0.01-0.87-0.16-0.89-0.85c-0.13-4.5,3.4-8.53,7.91-8.98c4.72-0.47,8.94,2.66,9.76,7.25c0.46,2.54,0.44,2.56-2.13,2.56 C22.44,18.91,20.23,18.91,18.03,18.91z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvening);
export default __webpack_public_path__ + "static/media/Evening.1b55139a0ef73ab6c7c25624fdcbf3f2.svg";
export { ForwardRef as ReactComponent };